<div [class.no-borders]="labelOnly">
  <table mat-table [dataSource]="tableDataSource" class="mat-elevation-z8 custom-table">
    <!-- Label -->
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef>{{ title }}</th>
      <td mat-cell *matCellDef="let element" [ngClass]="{ 'disabled-row': element.disabled }">
        <div class="label-col-container">
          <div [style.background-color]="element.disabled ? '#F4F4F4' : element.color" class="color-box"></div>
          <div>{{ element.label }}</div>
        </div>
      </td>
    </ng-container>

    <!-- Count / Percentage -->
    <ng-container matColumnDef="metric">
      <th mat-header-cell *matHeaderCellDef>
        <div class="percentage-count-switch-container">
          <div class="switch-buttons-wrap">
            <button
              [ngClass]="{ 'switch-button': true, 'switch-button-selected': percentageSelected }"
              (click)="onPercentageSwitchButtonClicked()"
            >
              %
            </button>
            <button
              [ngClass]="{ 'switch-button': true, 'switch-button-selected': !percentageSelected }"
              (click)="onCountSwitchButtonClicked()"
            >
              #
            </button>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let element" class="count-percentage-value">
        {{ percentageSelected ? element.percentage.toFixed(2) + '%' : element.count }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr
      [ngClass]="{ 'interactive-row': !static }"
      mat-row
      *matRowDef="let row; columns: tableColumns; let i = index"
      (click)="onRowSelected(row, i)"
    ></tr>
  </table>
</div>
